import { getAttrValue, isNumber, isString } from '@grandvisionhq/utils';

const getAttribute = (variant, attrName)=>{
    const attrValue = getAttrValue(variant, attrName);
    if (isNumber(attrValue) || isString(attrValue)) {
        return String(attrValue);
    }
    return '';
};

export { getAttribute };
//# sourceMappingURL=get-line-item-attribute.js.map
